'use client';

import { DeliveryType } from '@ahm/api-wrappers-core';
import { formatCurrency, parseSafeValue } from '@ahm/common-helpers';
import { useLocationStore } from '@ahm/react-map/store';
import { Box, type BoxProps, Table } from '@mantine/core';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';
import { useGetServiceTypes } from '@/features/booking/api/service';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';

type Props = BoxProps;

export function ListDetailCod({ ...props }: Props) {
  const tBooking = useTranslations('booking');
  const paths = useLocationStore.use.paths();
  const isMobile = useIsMobile();

  const { data: serviceTypes } = useGetServiceTypes(
    {
      lat: paths[0]?.lat ?? 0,
      lng: paths[0]?.lng ?? 0,
      delivery_type: DeliveryType.Nationwide,
    },
    {
      enabled: Boolean(paths?.[0]),
    }
  );
  const services = useMemo(() => {
    if (!serviceTypes) return [];
    return serviceTypes;
  }, [serviceTypes]);

  const rows = services.map((element) => (
    <tr key={element.name}>
      <td>{element.name}</td>
      <td>{parseSafeValue(formatCurrency(element.max_cod_per_stop_point))}</td>
      <td>{parseSafeValue(formatCurrency(element.max_cod))}</td>
    </tr>
  ));

  return (
    <Box
      style={{
        height: '100%',
        maxHeight: isMobile ? 'auto' : 180,
        overflowY: 'auto',
      }}
      {...props}
    >
      <Box px={16}>
        <Table>
          <thead>
            <tr>
              <th style={{ fontSize: 12 }}>
                {tBooking('location.modal_learn_about_cod_column_service_name')}
              </th>
              <th style={{ fontSize: 12 }}>
                {tBooking(
                  'location.modal_learn_about_cod_column_cod_each_stop_point'
                )}
              </th>
              <th style={{ fontSize: 12 }}>
                {tBooking('location.modal_learn_about_cod_column_total_cod')}
              </th>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </Table>
      </Box>
    </Box>
  );
}
